/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Grid, TextField } from "@mui/material";
import { toCamelCase } from "../../../utils/helperFunctions";
import { createDialogStyles as styles } from "../styles";
import ConvoyDialog from "../../../components/ConvoyDialog";
import { useAddUser } from "../../../api/users";
import { UpdateManagerField } from "./UpdateManager";

const AddUserDialog = ({
  open,
  people,
  resetDialog,
  displayNotification,
  callback,
}) => {
  const [payload, setPayload] = useState({});

  const {
    postData: addUser,
    response: addUserResp,
    responseStatus: addUserStatus,
  } = useAddUser();

  useEffect(() => {
    if (!open) {
      setPayload({});
    }
  }, [open]);

  useEffect(() => {
    displayNotification(addUserResp, addUserStatus, callback);
  }, [addUserResp, addUserStatus]);

  const handleDialogConfirm = () => {
    addUser(payload);
    resetDialog();
  };

  const textFieldCommonProps = (label) => ({
    fullWidth: true,
    label: label,
    color: "secondary",
    value: payload?.[toCamelCase(label)] || "",
    onChange: (e) => {
      let value = e.target.value;

      if (["Email Id", "Github Id", "Slack Id"].includes(label)) {
        // Remove all spaces and newlines
        value = value.replace(/[\s\n\r]/g, "");
      }

      setPayload((prev) => ({
        ...prev,
        [toCamelCase(label)]: value,
      }));
    },
  });

  const getNameValidationError = () => {
    const name = payload?.name;
    if (!name) return null;
    if (name.includes("\n") || name.includes("\r")) {
      return "Name cannot contain newlines";
    }
    if (name.endsWith(" ")) {
      return "Name cannot end with spaces";
    }
    return null;
  };

  const isFormValid = () => {
    const nameError = getNameValidationError();
    return (
      payload?.githubId &&
      payload?.slackId &&
      payload?.emailId &&
      payload?.managerEmailId &&
      !nameError
    );
  };

  return (
    <ConvoyDialog
      open={open}
      title={`Add user`}
      handleDialogConfirm={handleDialogConfirm}
      resetDialog={resetDialog}
      onCancelClick={resetDialog}
      disabled={!isFormValid()}
    >
      <Grid container spacing={2} sx={styles.inputGridContainer}>
        <Grid item xs={4}>
          <TextField
            {...textFieldCommonProps("Name")}
            helperText={getNameValidationError()}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField {...textFieldCommonProps("Github Id")} />
        </Grid>
        <Grid item xs={4}>
          <TextField {...textFieldCommonProps("Slack Id")} />
        </Grid>
        <Grid item xs={6}>
          <TextField {...textFieldCommonProps("Email Id")} />
        </Grid>
        <Grid item xs={6}>
          <UpdateManagerField
            payload={payload}
            setPayload={setPayload}
            people={people}
          />
        </Grid>
      </Grid>
    </ConvoyDialog>
  );
};

export default AddUserDialog;
